import styled from 'styled-components';

export const UiCreateQuestionnairePage = styled.div``;